import React from "react"

import ArticleHero from "@components/elements/V2/ArticleHero"

const StoryblokArticleHero = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.ArticleHero>) => {
  return (
    <ArticleHero
      category={blok.category}
      title={blok.title}
      subscript={blok.subscript}
      backgroundColor={blok.backgroundColor}
      imageAlt={blok.image.alt}
      imageUrl={blok.image.filename}
      mobileGridOrder={mobileGridOrder}
    />
  )
}

export default StoryblokArticleHero
